export const cookieEnum = {
    ACCESS_TOKEN: "access_token",
    USER_TYPE: "user_type",
    USER: "user",
    TOKEN_DATA: "token_data"
};
